import { isSchema as e } from "@scalar/workspace-store/schemas/v3.2/strict/type-guards";
//#region src/schema/helpers/get-property-description.ts
var t = {
	integer: {
		_default: "schema.typeInteger",
		int32: "schema.formatInt32",
		int64: "schema.formatInt64"
	},
	string: {
		date: "schema.formatDate",
		"date-time": "schema.formatDateTime",
		password: "schema.formatPassword",
		base64: "schema.formatBase64",
		byte: "schema.formatBase64",
		binary: "schema.formatBinary"
	}
}, n = (n) => {
	if (!e(n)) return null;
	let r = Array.isArray(n.type) ? n.type[0] : n.type;
	if (!r) return null;
	let i = t[r];
	return i ? i["format" in n && n.format || "contentEncoding" in n && n.contentEncoding || "_default"] ?? null : null;
};
//#endregion
export { n as getPropertyDescriptionKey };

//# sourceMappingURL=get-property-description.js.map